import { createContext, useContext, useEffect, useMemo, useState } from 'react';

import { STORAGE_KEYS } from '../../../core/constants/storage';

const THEMES = ['system', 'light', 'dark'];
const ThemeContext = createContext(null);

function readStoredTheme() {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEYS.THEME);
        return THEMES.includes(stored) ? stored : 'system';
    } catch {
        return 'system';
    }
}

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(readStoredTheme);

    useEffect(() => {
        const root = document.documentElement;
        if (theme === 'system') root.removeAttribute('data-theme');
        else root.setAttribute('data-theme', theme);
        try {
            window.localStorage.setItem(STORAGE_KEYS.THEME, theme);
        } catch {
            // Private mode or a sandboxed iframe can block storage; the theme still applies.
        }
    }, [theme]);

    const value = useMemo(() => ({ theme, themes: THEMES, setTheme }), [theme]);
    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
    const context = useContext(ThemeContext);
    if (!context) throw new Error('useTheme must be used inside <ThemeProvider>');
    return context;
}
